enum DateFormat {
  Display = 'DD/MM/YYYY',
  DisplayFull = 'dddd, Do MMMM YYYY',
  ISO8601 = 'YYYY-MM-DD',
  DisplayMonthName = 'D MMMM YYYY',
  Numeric = 'DDMMYYYY',
}

enum DatePickerFormat {
  Display = 'dd/MM/yyyy',
  ISO8601 = 'yyyy-MM-dd',
  DisplayMonthName = 'd MMMM yyyy',
  Numeric = 'ddMMyyyy',
}

enum MonthPickerFormat {
  Display = 'MM/YYYY',
  ISO8601 = 'yyyy-MM',
  DisplayMonthName = 'MMM yyyy',
  Numeric = 'MMYYYY',
}

enum BooleanSelection {
  Yes = 'YES',
  No = 'NO',
}

enum RequestState {
  error = 'error',
  loading = 'loading',
  success = 'success',
}

type SelectOptions = Array<{ label: string; value: string }>;

export {
  DateFormat,
  DatePickerFormat,
  MonthPickerFormat,
  BooleanSelection,
  RequestState,
};
export type { SelectOptions };
